import React from 'react';
import { Table } from 'antd';
import Colors from '../../utils/colors';

const CustomTable = ({
  columns,
  dataSource,
  loading,
  rowKey = '_id',
  currentPage,
  total,
  pageSize,
  showTotal,
  onChange,
  scroll = { x: 800 },
  expandable
}) => {
  return (
    <div style={{ width: '100%', overflowX: 'auto', border: `1px solid ${Colors.lightGray}`, borderRadius: 10 }}>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={rowKey}
        pagination={{
          current: currentPage,
          total: total,
          pageSize: pageSize,
          showTotal: showTotal,
          itemRender: (current, type, originalElement) => {
            if (type === 'page') {
              return (
                <span style={{
                  backgroundColor: current === currentPage ? Colors.primary : 'transparent',
                  color: current === currentPage ? Colors.white : Colors.primary,
                  border: `1px solid ${Colors.primary}`,
                  padding: '4px 8px',
                  borderRadius: 4,
                  cursor: 'pointer'
                }}>
                  {current}
                </span>
              )
            }
            return originalElement
          }
        }}
        onChange={onChange}
        scroll={scroll}
        size="middle"
        expandable={expandable}
      />
    </div>
  );
};

export default CustomTable;